/* ==========================================================================
   Pur Plant — Product card behaviour (standalone)

   WPO 22ago. Sustituye a los dos IIFE que se emitian INLINE despues de CADA
   tarjeta en snippets/pp-product-card-standalone.liquid.

   Que cambia respecto al original, y por que (INP):

   1. Los listeners pasan de `document` a CADA TARJETA.
      Antes: mouseenter/mouseleave en FASE DE CAPTURA sobre document. Esos
      eventos no burbujean, pero en captura llegan por cada elemento al que
      entra el puntero: cientos de disparos por pagina, cada uno con un
      closest() ascendiendo el arbol.

   2. El arrastre usa Pointer Events con setPointerCapture, no mousemove global.
      Antes: document.addEventListener('mousemove', ...) SIN passive y con
      preventDefault(). El navegador no puede optimizar un listener asi, de modo
      que cada movimiento del raton sobre cualquier punto de la pagina entraba
      en el hilo principal. Con pointer capture el seguimiento vive en el track
      y desaparecen tambien los mouseup/mouseleave globales.

   3. El ancho del track se cachea con ResizeObserver.
      Antes: track.offsetWidth se leia DENTRO de cada handler -> layout sincrono
      forzado en mitad de una interaccion.

   4. Inicializacion diferida con IntersectionObserver: las fichas por debajo
      del pliegue no enganchan nada hasta acercarse al viewport.

   IMPORTANTE — alcance del quick add: el manejador esta ACOTADO a la tarjeta.
   Los botones data-pp-add-to-cart de la pagina de producto
   (.pp-pdp__add-to-cart-btn y .pp-pdp__routine-add) tienen sus propios
   manejadores en assets/pp-product-main.js. La delegacion global anterior
   tambien los capturaba, provocando doble anadido cuando habia una ficha en la
   PDP (seccion de recomendaciones). Acotarlo lo corrige.
   ========================================================================== */

(function () {
  if (window.__ppProductCardInit) return;

  /* Durante la migracion pueden coexistir los <script> inline del snippet.
     Se ejecutan antes (este modulo va diferido), asi que si ya han enganchado
     sus listeners globales nos apartamos: evita doble binding en el estado
     intermedio. Cuando el snippet quede limpio, estas flags no existiran. */
  if (window.ppQuickAddInitialized || window.ppCardSliderInitialized) return;

  window.__ppProductCardInit = true;
  window.ppQuickAddInitialized = true;
  window.ppCardSliderInitialized = true;

  var CARD_SEL = '.pp-product-card-standalone';
  var READY_ATTR = 'data-pp-card-ready';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- */
  /* Quick add                                                        */
  /* ---------------------------------------------------------------- */

  function bumpCartIcon() {
    try {
      var trigger = document.querySelector('[data-cart-drawer-trigger]');
      if (!trigger) return;
      trigger.classList.remove('pp-cart-bump');
      void trigger.offsetWidth; /* reinicia la animacion en adds seguidos */
      trigger.classList.add('pp-cart-bump');
      setTimeout(function () { trigger.classList.remove('pp-cart-bump'); }, 550);
    } catch (e) {}
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;

    button.classList.add('is-loading');
    var originalText = button.textContent;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      var addedItem = await response.json();

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      /* Variante B: en desktop el boton principal muestra "Anadido"; chips de
         variante y movil, solo el tick. */
      if (button.classList.contains('pp-card__quick-add-single') && window.matchMedia('(min-width: 750px)').matches) {
        button.textContent = 'A\u00f1adido';
      } else {
        button.textContent = '\u2713';
      }

      /* PP <1€ sanity: clamp any line with price<100c & qty>1 to qty=1.
         Cubre rapid-click ATC en cards desde colecciones/landings. */
      if (window.ppLimitUnder1) {
        try {
          var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
          var fixes = (cart.items || []).filter(function (it) {
            return it.price < 100 && it.quantity > 1;
          }).map(function (it) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 1 })
            });
          });
          if (fixes.length) await Promise.all(fixes);
        } catch (e) {}
      }

      /* Actualizacion del contador (fire-and-forget) */
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { cart: cart, items: [addedItem] } }));
      }).catch(function () {});

      /* Variante B (test A/B quick add): NO abrir el carrito, solo refrescar. */
      if (typeof window.ppRefreshCartDrawer === 'function') {
        window.ppRefreshCartDrawer({ open: false });
      }

      bumpCartIcon();

      setTimeout(function () {
        button.classList.remove('is-added');
        button.textContent = originalText;
      }, 1500);

    } catch (error) {
      console.error('Error adding to cart:', error);
      button.classList.remove('is-loading');
      button.textContent = originalText;
    }
  }

  /* ---------------------------------------------------------------- */
  /* Controlador por tarjeta                                          */
  /* ---------------------------------------------------------------- */

  function PPCard(card) {
    this.card = card;
    this.track = card.querySelector('[data-pp-slider-track]');
    this.slides = this.track ? this.track.querySelectorAll('.pp-card__slide').length : 0;
    this.width = 0;
    this.drag = null;
    this.bind();
  }

  PPCard.prototype.measuredWidth = function () {
    /* this.width lo mantiene el ResizeObserver. El offsetWidth solo se lee si
       el observer aun no ha medido (primer frame o navegador sin soporte). */
    return this.width || (this.track ? this.track.offsetWidth : 0);
  };

  /* Rellena los slides diferidos (indice 2 en adelante). El snippet los emite
     con data-src y un SVG transparente como src, de modo que el navegador no
     pide nada hasta que hay intencion real de ver mas fotos. Idempotente: la
     bandera evita recorrer el DOM en cada gesto posterior. */
  PPCard.prototype.hydrate = function () {
    if (this.hydrated || !this.track) return;
    this.hydrated = true;
    var imgs = this.track.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    }
  };

  PPCard.prototype.goTo = function (index, loop) {
    if (!this.track || !this.slides) return;
    if (loop) {
      if (index < 0) index = this.slides - 1;
      if (index >= this.slides) index = 0;
    } else {
      if (index < 0) index = 0;
      if (index >= this.slides) index = this.slides - 1;
    }
    var w = this.measuredWidth();
    if (!w) return;
    this.track.scrollTo({ left: w * index, behavior: 'smooth' });
  };

  PPCard.prototype.currentIndex = function () {
    var w = this.measuredWidth();
    if (!w) return 0;
    return Math.round(this.track.scrollLeft / w);
  };

  PPCard.prototype.bind = function () {
    var self = this;
    var card = this.card;

    /* --- Clicks, acotados a la tarjeta --- */
    card.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pp-add-to-cart]');
      if (add) {
        e.preventDefault();
        e.stopPropagation();
        if (!add.disabled && add.dataset.variantId) addToCart(add.dataset.variantId, add);
        return;
      }
      var prev = e.target.closest('[data-pp-slider-prev]');
      if (prev) {
        e.preventDefault();
        e.stopPropagation();
        self.hydrate();
        self.goTo(self.currentIndex() - 1, true);
        return;
      }
      var next = e.target.closest('[data-pp-slider-next]');
      if (next) {
        e.preventDefault();
        e.stopPropagation();
        self.hydrate();
        self.goTo(self.currentIndex() + 1, true);
      }
    });

    if (!this.track || this.slides <= 1) return;

    /* --- Ancho cacheado: nada de offsetWidth dentro de los handlers --- */
    if (typeof ResizeObserver === 'function') {
      this.ro = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var box = entry.contentBoxSize;
          self.width = (box && box[0]) ? box[0].inlineSize : entry.contentRect.width;
        }
      });
      this.ro.observe(this.track);
    }

    /* --- Hover: segunda imagen al entrar, primera al salir (solo desktop) --- */
    if (canHover) {
      card.addEventListener('mouseenter', function () { self.goTo(1, false); });
      card.addEventListener('mouseleave', function () { self.goTo(0, false); });
    }

    /* --- Hidratacion de los slides diferidos ---
       Va SEPARADO del arrastre a proposito. El handler de arrastre de abajo
       ignora todo lo que no sea raton (en tactil se deja el scroll nativo con
       scroll-snap), asi que si colgaramos de el la hidratacion, en movil no se
       dispararia nunca.

       pointerdown cubre dedo, lapiz y raton, y salta AL POSAR, antes de que el
       scroll empiece a moverse: da ~100-300ms de ventaja para que la imagen
       llegue a tiempo.
       scroll (once) es la red de seguridad para lo que no genera pointerdown:
       trackpad de dos dedos, rueda horizontal, navegacion por teclado. */
    var hydrateOnce = function () { self.hydrate(); };
    this.track.addEventListener('pointerdown', hydrateOnce, { passive: true });
    this.track.addEventListener('scroll', hydrateOnce, { passive: true, once: true });

    /* NO se hidrata en mouseenter a proposito: en escritorio el raton cruza
       muchas fichas sin intencion de comprarlas y acabariamos descargando los
       slides de media pagina, que es justo lo que este cambio evita. El hover
       sigue cargando el slide 1, que se emite normal. */

    /* --- Arrastre con Pointer Events, capturado en el track --- */
    this.track.addEventListener('pointerdown', function (e) {
      /* Tactil y lapiz: se deja el scroll nativo con scroll-snap, que ya
         funciona y es mas fluido que emularlo desde JS. */
      if (e.pointerType !== 'mouse') return;
      if (e.target.closest('[data-pp-slider-prev], [data-pp-slider-next]')) return;

      self.drag = {
        id: e.pointerId,
        startX: e.clientX,
        startScroll: self.track.scrollLeft,
        moved: false
      };
      try { self.track.setPointerCapture(e.pointerId); } catch (err) {}
      self.track.classList.add('is-dragging');
      e.preventDefault(); /* evita el drag nativo de imagenes y la seleccion */
    });

    this.track.addEventListener('pointermove', function (e) {
      var d = self.drag;
      if (!d || e.pointerId !== d.id) return;
      var walk = (d.startX - e.clientX) * 1.5;
      if (Math.abs(walk) > 3) d.moved = true;
      self.track.scrollLeft = d.startScroll + walk;
    }, { passive: true });

    function endDrag(e) {
      var d = self.drag;
      if (!d || (e && e.pointerId !== d.id)) return;
      self.drag = null;
      self.track.classList.remove('is-dragging');
      try { self.track.releasePointerCapture(e.pointerId); } catch (err) {}
      if (d.moved) self.goTo(self.currentIndex(), false);
    }

    this.track.addEventListener('pointerup', endDrag);
    this.track.addEventListener('pointercancel', endDrag);
  };

  /* ---------------------------------------------------------------- */
  /* Inicializacion diferida                                          */
  /* ---------------------------------------------------------------- */

  function initCard(card) {
    if (card.hasAttribute(READY_ATTR)) return;
    card.setAttribute(READY_ATTR, '');
    try {
      new PPCard(card);
    } catch (e) {
      console.error('pp-product-card init failed:', e);
    }
  }

  var io = null;
  if (typeof IntersectionObserver === 'function') {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          io.unobserve(entries[i].target);
          initCard(entries[i].target);
        }
      }
    }, { rootMargin: '300px' });
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll(CARD_SEL + ':not([' + READY_ATTR + '])');
    for (var i = 0; i < cards.length; i++) {
      if (io) io.observe(cards[i]);
      else initCard(cards[i]);
    }
  }

  /* Las fichas tambien llegan por inyeccion: refresco del cart drawer, Section
     Rendering API, pestanas de coleccion. Antes la delegacion en document las
     cubria sola. Un MutationObserver debounced hace ese papel, y solo trabaja
     cuando el DOM cambia — no en cada movimiento del raton. */
  var scanTimer = null;
  function queueScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scan(document);
    }, 100);
  }

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) {
        queueScan();
        return;
      }
    }
  });

  function start() {
    scan(document);
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function () { scan(document); });

  /* Escotilla manual por si algun script necesita forzar el escaneo */
  window.ppInitProductCards = scan;
})();
